import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useModalContext } from "@/components/General/Modal/context/modal.context";

type Props = {
    className?: string;
};

export const ConfirmButton = ({ className }: Props) => {
    const {
        formId,
        confirmButtonColor,
        confirmButtonText,
        isLoading,
        isConfirmDisabled,
        onConfirm
    } = useModalContext();

    if (!confirmButtonText) return null;

    return (
        <Button
            className={cn(className)}
            type={formId ? "submit" : "button"}
            form={formId}
            color={confirmButtonColor}
            onClick={onConfirm}
            loading={isLoading}
            disabled={isConfirmDisabled}
        >
            {confirmButtonText}
        </Button>
    );
};
